module.exports = __webpack_public_path__ + "img/logo_2.f00c9511.png";